import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { REQUEST } from '@personal-area/common';
import { CookieOptions, CookieService } from 'ngx-cookie-service';

import { Observable } from 'rxjs';

import { STORAGE_CONFIG } from '../tokens/config.token';

@Injectable({
  providedIn: 'root',
})
export class UniversalStorageService implements Storage {
  protected _req = inject(REQUEST);
  private _config = inject(STORAGE_CONFIG);

  readonly length = 0;

  constructor(
    private _http: HttpClient,
    protected _cookieService: CookieService,
  ) {
  }

  public clear(): void {
    this._cookieService.deleteAll();
  }

  public getItem(key: string): string {
    if (this._config.isServer && this._req.cookies) {
      return this._req.cookies[key];
    }

    return this._cookieService.get(key);
  }

  public key(index: number): string {
    const cookies = this._config.isServer && this._req.cookies
      ? this._req.cookies
      : this._cookieService.getAll();
    return Object.keys(cookies)[index];
  }

  public removeItem(key: string): void {
    this._cookieService.delete(key);
  }

  public setItem(key: string, data: string, options?: CookieOptions): void {
    if (this._config.isServer && this._req.cookies) {
      this._req.cookies[key] = data;
    }

    this._cookieService.set(key, data, {
      ...options,
      secure: true,
    });
  }

  public check(key: string): boolean {
    if (this._config.isServer && this._req.cookies) {
      return key in this._req.cookies;
    }
    return !!this._cookieService.getAll()[key];
  }

  public delete(key: string, options: CookieOptions, removeOnDomain = true): void {
    if (!this._config.isServer) {
      this._cookieService.delete(key, options.path, options.domain, options.secure, options.sameSite);
      if (removeOnDomain) {
        this._cookieService.delete(key, options.path, undefined, options.secure, options.sameSite);
      }
    }
  }

  public set(key: string, data: string, options?: CookieOptions, expires?: number): void {
    if (expires && options) {
      options.expires = new Date(new Date().getTime() + expires * 1000 * 60 * 60 * 24);
    }
    this._cookieService.set(key, data, {
      ...options,
      secure: true,
    });
  }

  public setHttpOnlyItem(key: string, value?: string, options?: CookieOptions, expires?: number): Observable<void> {
    const params = new URLSearchParams();

    params.set('name', key);

    if (options) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      Object.keys(options).forEach(k => params.set(k, encodeURIComponent(options[k])));
    }
    if (expires) {
      params.set('expires', ((Date.now() / 1000) + (expires * 60 * 60 * 24)).toFixed(0).toString());
    }
    if (value) {
      params.set('value', encodeURIComponent(value));
    }

    return this._http.get<void>(`/site/setcookie?${params.toString()}`);
  }

  public removeHttpOnlyItem(key: string, options?: CookieOptions): Observable<void> {
    return this.setHttpOnlyItem(key, undefined, options);
  }

}
